import React, { useState, useEffect, Fragment } from 'react';
import IntlMessages from '../../../../helpers/IntlMessages';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './table.scss';
import moment from 'moment';

export default function AriDatePicker({ getStartDate }) {
  // ✅ Date object for DatePicker
  const [startDate, setStartDate] = useState(new Date());
  const [daysArr, setDaysArr] = useState([]);

  const daysArrGenerator = (start, stop) => {
    let arr = [];
    while (start < stop) {
      arr.push(moment(start));
      start = moment(start).add(1, 'days').toDate(); // ✅ increment as Date
    }
    return arr;
  };

  useEffect(() => {
    setDaysArr(
      daysArrGenerator(
        startDate,
        moment(startDate).add(30, 'days').toDate()
      )
    );
  }, [startDate]);

  const handldDateChange = (date) => {
    setStartDate(date); // ✅ Date object
    getStartDate(moment(date).format('YYYY-MM-DD')); // if API needs moment format
  };

  const moveDays = (e, direction) => {
    e.preventDefault();
    if (direction === 'left') {
      setStartDate((prev) =>
        moment(prev).subtract(4, 'days').toDate()
      );
    }
    if (direction === 'right') {
      setStartDate((prev) =>
        moment(prev).add(4, 'days').toDate()
      );
    }
  };

  return (
    <Fragment>
      <div className="fix">-</div>
      <div className="top">
        <div className="date-picker">
          <div className="form-group has-float-label">
            <DatePicker
              selected={startDate} // ✅ Date object
              onChange={handldDateChange}
              dateFormat="dd/MM/yyyy"
              placeholderText="Select a date"
            />
            <IntlMessages id="forms.date" />
          </div>
        </div>
        <div className="date-chevron">
          <FontAwesomeIcon
            icon={faChevronLeft}
            onClick={(e) => moveDays(e, 'left')}
          />
        </div>
        <div className="date-chevron">
          <FontAwesomeIcon
            icon={faChevronRight}
            onClick={(e) => moveDays(e, 'right')}
          />
        </div>
        <div className="date-list">
          <div className="date-blank">x</div>
          {daysArr.map((day, index) => (
            <Fragment key={index}>
              {day.format('ddd') === 'Sat' || day.format('ddd') === 'Sun' ? (
                <div className="date-cell-gray">
                  <div>
                    {day.format('DD MMM')} <b>({day.format('ddd')[0]})</b>
                  </div>
                </div>
              ) : (
                <div className="date-cell">
                  <div>
                    {day.format('DD MMM')} <b>({day.format('ddd')[0]})</b>
                  </div>
                </div>
              )}
            </Fragment>
          ))}
        </div>
      </div>
    </Fragment>
  );
}
